import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl';

import SidePanelContainer from '../panels/sidePanel/sidePanel-transition'
import {openSidePanelPage} from '../panels/sidePanel/sidePanel-action'

import Page from '../page/page'
import Button from '../button/button'
import ButtonPush from '../button/button-push'
import Switch from '../form/form-switch'

import List from '../list/list'
import ModulePage from './module-page'

import './module.styl'
class ModuleList extends React.Component {
    static SIDE_PANEL_ID = 0;

    constructor(props) {
        super(props)
        this.sidePanelId = "sidePanel-moduleList-" + (ModuleList.SIDE_PANEL_ID++)
        this.i18n = 'app.modules.'

        this.state = {
            open: false,
            modules: props.modules
        }
    }

    open(module) {
        openSidePanelPage(this.sidePanelId, ModulePage, {attrs: module}, 'app.modules.list')
    }

    visible(module) {
        module.visibility = !module.visibility
        this.setState(this.state)
    }

    header(module) {
        let { remove=console.log } = this.props

        return <div className="module-list-header">
            <Button onClick={e => this.open(module)} icon='plus' />
            <label>{module.title}</label>
            <div className="buttons">
                <ButtonPush onClick={e => this.visible(module)} value={module.visibility} iconOn='eye' iconOff='eyeBlocked' />
                <Button onClick={remove} icon='bin' />
            </div>
        </div>
    }

    body(module) {
        return <div>
            ce ci est un module
        </div>
    }

    render() {
        return <div className="module-list">
            <List collection={this.props.collection.map(module =>
                <Page className={'module'  + (module.visibility ? '' : ' disabled')}
                    header={this.header(module)}
                    body={this.body(module)} />
            )} />
            <SidePanelContainer id={this.sidePanelId} />
        </div>
    }
}

ModuleList.propTypes = {
    collection: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            visibility: PropTypes.bool.isRequired,
            optionsDefault: PropTypes.object.isRequired,
            modulesSchedules: PropTypes.array.isRequired
        }))
}

export default ModuleList;
